import React, { useState } from 'react';
import { Button, Modal, Form, TextArea } from 'semantic-ui-react';
import { IRating } from '../../app/interfaces/IRating';
import VendorRatingStars, { StarSize } from '../stars/VendorRatingStars';

interface EditRatingModalProps {
    rating: IRating;
    open: boolean;
    onClose: () => void;
    onSave: (ratingValue: number, comment: string | null) => void;
}

export const EditRatingModal = ({ rating, open, onClose, onSave }: EditRatingModalProps) => {
    const [stars, setStars] = useState<number>(rating.rating || 0);
    const [comment, setComment] = useState<string>(rating.description || '');

    const handleSave = () => {
        onSave(stars, comment || null);
    };

    return (
        <Modal open={open} closeIcon onClose={onClose} size='small'>
            <Modal.Header>Edit Rating</Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Field>
                        <label>Rating</label>
                        <VendorRatingStars
                            size={StarSize.Large}
                            stars={stars}
                            updateStars={setStars}
                        />
                    </Form.Field>
                    <Form.Field>
                        <label>Comment</label>
                        <TextArea
                            value={comment}
                            onChange={(_, data) => setComment(data.value as string)}
                            placeholder='Leave a comment...'
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>Cancel</Button>
                <Button positive onClick={handleSave} disabled={stars === 0}>
                    Save
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
